/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface EventType {
  id: number;
  header: string;
  code: string;
  isSystem: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  enabled: boolean;
  deleted?: boolean;
  target?: number;
}
